"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getWidgetRequiredVersion = getWidgetRequiredVersion;
exports.resolveWidgetRenderVersion = resolveWidgetRenderVersion;
exports.resolveWidgetEditorVersion = resolveWidgetEditorVersion;
const dataModel_1 = require("./dataModel");
/**
 * Returns the lowest query-engine version required by a widget definition.
 * This is shape classification only; persistence policy remains owned by
 * DashboardService.
 */
function getWidgetRequiredVersion(shape) {
    return (0, dataModel_1.requiresV2)(shape) ? 2 : 1;
}
function resolveEffectiveWidgetVersion(params) {
    return getWidgetRequiredVersion(params.shape) >= 2 ||
        (params.versionFloor ?? 1) >= 2 ||
        params.targetVersion === "v2"
        ? "v2"
        : "v1";
}
/**
 * Selects the newest readable query declaration for a persisted widget.
 * This does not decide or mutate the widget's persisted minVersion.
 */
function resolveWidgetRenderVersion(params) {
    return resolveEffectiveWidgetVersion({
        shape: params.shape,
        versionFloor: params.persistedMinVersion,
        targetVersion: params.newestReadableVersion,
    });
}
/**
 * Selects the declaration used by the widget editor for the active UI mode.
 * The editor's base version is a local floor; saving remains server-owned.
 */
function resolveWidgetEditorVersion(params) {
    return resolveEffectiveWidgetVersion({
        shape: params.shape,
        versionFloor: params.baseMinVersion,
        targetVersion: params.activeVersion,
    });
}
